import axios from 'axios';

import { API_BASE_URL } from 'constants/urls';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.validateStatus = status => status >= 200 && status < 300;
